import { Box, Pagination } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import usePersistedColumnVisibility from 'shared/hooks/usePersistedColumnVisibility';
import { buildGridToolbarExportProps } from 'shared/utils/tableExportFileName';

/**
 * Shared DataGrid table. Pass `tableId` so column show/hide choices persist per table across reloads.
 * Pass `title` so Export downloads a file named after this table.
 */
const Table = ({
  rows = [],
  columns,
  totalRecords,
  size,
  page = 0,
  colors,
  handlePageChange,
  tableId,
  title,
}) => {
  const resolvedTableId = tableId || 'shared.table';
  const { columnVisibilityModel, onColumnVisibilityModelChange } =
    usePersistedColumnVisibility(resolvedTableId);
  const toolbarSlotProps = buildGridToolbarExportProps({
    title,
    tableId: resolvedTableId,
    showQuickFilter: true,
    quickFilterProps: { debounceMs: 500 },
  });

  return (
    <Box
      height="72vh"
      sx={{
        '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
          color: `${colors.grey[100]} !important`,
        },
      }}
    >
      <DataGrid
        disableRowSelectionOnClick
        rows={rows}
        columns={columns}
        pagination
        paginationMode="server"
        rowCount={totalRecords}
        pageSize={size}
        page={page}
        onPageChange={(newPage) => {
          handlePageChange(newPage);
        }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={onColumnVisibilityModelChange}
        slotProps={{
          toolbar: toolbarSlotProps,
        }}
        slots={{
          toolbar: GridToolbar,
          pagination: () => (
            <Box display="flex" justifyContent="center" p={2}>
              <Pagination
                count={Math.max(1, Math.ceil(totalRecords / size))}
                page={page + 1}
                onChange={(_, newPage) => {
                  handlePageChange(newPage - 1);
                }}
                variant="outlined"
                shape="rounded"
              />
            </Box>
          ),
        }}
      />
    </Box>
  );
};

export default Table;
